import { Link } from 'react-router-dom'
import { Settings } from '@/types'
import './Hero.css'

interface HeroProps {
  settings: Partial<Settings>
}

function Hero({ settings }: HeroProps) {
  const {
    candidate_name = 'Avenir Théopolitain 2026',
    slogan = 'Pour un avenir meilleur',
  } = settings

  return (
    <section className="hero">
      <div className="hero-overlay"></div>
      <div className="container hero-content">
        <div className="hero-text">
          <h1 className="hero-title">{candidate_name}</h1>
          {slogan && <p className="hero-slogan">{slogan}</p>}
          <div className="hero-cta">
            <Link to="/le-projet" className="btn btn-primary btn-large">
              Découvrir le projet
            </Link>
            <Link to="/contact" className="btn btn-outline btn-large">
              Nous contacter
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
